import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { FindCaseBySymbolsIdRq, LoanCaseDTO } from "@smartx/mikro-vt-client-api"
import { findCasesApi } from "../../api/apiClient"
import type { RootState } from "../../app/store"
import { RequestHeader } from "../../utils/utils"

interface CasesState {
  list: Array<LoanCaseDTO>
  isLoading: boolean
  error: boolean
  selected: LoanCaseDTO
}

const initialState: CasesState = {
  list: undefined,
  isLoading: false,
  error: false,
  selected: null,
}

const rq: FindCaseBySymbolsIdRq = { header: new RequestHeader() }

export const getCases = createAsyncThunk("cases/getCases", async () => {
  const response = await findCasesApi.findCaseBySymbolsId(rq)
  return response?.data
})

export const casesSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    setCases: (state, action: PayloadAction<LoanCaseDTO[]>) => {
      state.list = action.payload
    },
    clearCases: (state) => {
      state.list = undefined
    },
    setCase: (state, action: PayloadAction<LoanCaseDTO>) => {
      state.selected = action.payload
    },
    clearCase: (state) => {
      state.list = undefined
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCases.pending, (state) => {
        state.isLoading = true
        state.error = false
      })
      .addCase(getCases.fulfilled, (state, action) => {
        state.list = action.payload.loanCases
        state.isLoading = false
        state.error = false
        state.selected = null
      })
      .addCase(getCases.rejected, (state) => {
        state.list = undefined
        state.isLoading = false
        state.error = true
      })
  },
})

export const { setCases, clearCases, setCase, clearCase } = casesSlice.actions

export const selectCases = (state: RootState) => state.cases.list

export default casesSlice.reducer
